import React from 'react'
import OffersEvaluation from "./OffersEvaluation";

function Index(
    {
        expanded
    }) {
    return (expanded && <OffersEvaluation />)
}


export default Index;